import moment from 'moment-timezone';

import { clampRangeToSpan } from '@src/components/RelativeAbsolutePeriodFilter';
import { clampCalendarRangeToToday, DateUtil } from '@src/packages/utils/dates';
import type { ExecutionsHistoryScheduleQuery } from '@src/models/interfaces/executionsHistoryDashboard.interface';

import type { ScheduleChartFilters } from '../../schedulesFilterConfig';
import { getScheduleIdsForApi, SCHEDULES_REPORT_MAX_SPAN } from '../../schedulesFilterConfig';

const DAY_FORMAT = 'YYYY-MM-DD';

export const buildScheduleHistoryQuery = (
  filters: ScheduleChartFilters,
  organizationId: string,
  divisionIds: string[],
  timeZone = DateUtil.getDefaultTimeZone(),
): ExecutionsHistoryScheduleQuery => {
  const now = moment.tz(timeZone);
  const from = filters.relative.isRelative
    ? now.clone().subtract(filters.relative.relativeAmount, filters.relative.dateType).startOf('day')
    : moment.tz(filters.dateRange[0].format(DAY_FORMAT), DAY_FORMAT, timeZone)
      .startOf(filters.relative.dateType);
  const to = filters.relative.isRelative
    ? now.clone().endOf('day')
    : moment.tz(filters.dateRange[1].format(DAY_FORMAT), DAY_FORMAT, timeZone)
      .endOf(filters.relative.dateType);
  const [rangeStart, rangeEnd] = clampRangeToSpan(
    clampCalendarRangeToToday([from, to], timeZone, now),
    filters.relative.isRelative ? 'day' : filters.relative.dateType,
    SCHEDULES_REPORT_MAX_SPAN,
  );

  return {
    organizationId,
    divisionIds,
    scheduleIds: getScheduleIdsForApi(filters.schedules),
    range: { from: rangeStart.format(DAY_FORMAT), to: rangeEnd.format(DAY_FORMAT) },
    interval: filters.groupBy,
  };
};
